import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CountryService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }

    getCountryList(isActive:number=-1) {
        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }
        return this.http.get(this.global.httpUrl+"countries"+isAvailable);
    }

    getCountryById(id: any) {
        return this.http.get(this.global.httpUrl+"countries/"+id);
    } 

    createCountry(data: any){
        return this.http.post(this.global.httpUrl+"countries", data); 
    }

    updateCountry(data: any,id: any){
        return this.http.put(this.global.httpUrl+"countries/"+id, data); 
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/countries/country.service.ts